import { api } from "@/lib/api";

export const trackSponsorClick = (x) => {
  if (x?.sponsored && x.sponsorId) api.post(`/sponsorships/${x.sponsorId}/click`, {}).catch(() => {});
};
